export default "__VITE_ASSET__6f9627d0__"